import axios from "axios";

export const doLogin = async ({ email, password, rememberMe }:{ email: string, password: string, rememberMe: boolean}) => {
	const vals = {
		email: email,
		password: password,
		remember: rememberMe
	};

	try {
		const res: any = await axios.post(`/auth/login`, vals);
		return res?.data;
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const refreshToken = async ({ data }: any) => {
	const config = {
		headers: { Authorization: `Bearer ${data.refreshToken}` },
	};

	try {
		const res: any = await axios.post("/auth/refresh-tokens", data, config);
		return res?.data;
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const sendForgotPassword = async ({ email } : {email: string}) =>{	
	try {
		const res: any = await axios.post("/auth/forgot-password", {email: email});
		return res?.data;
	} catch (e: any) {		
		return e?.response?.data ? e.response.data : e;
	}
}

export const resetPassword = async ({token, password, passwordConfirm} : { token: string, password: string, passwordConfirm: string }) =>{
	const vals = {
		token:token,
		password:password,    
		passwordConfirm:passwordConfirm,    
	}

	try {
		const res: any = await axios.post("/auth/reset-password", vals);
		return res?.data;
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
}

export const checkPasswordResetToken= async ({ token } : { token: string }) =>{
	const vals = {
		token:token,
	}

	try {
		const res: any = await axios.post("/auth/reset-password-check", vals);
		return res?.data;
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
}

export const getVerification = async () =>{
	try {
		const res: any = await axios.get("/auth/verify-token");
		return res?.data;		
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
}

export const completeRegistration = async ({ token, password, passwordConfirm } : { token: string, password: string, passwordConfirm: string }) =>{
	const vals = {
		token:token,
		password:password,    
		passwordConfirm:passwordConfirm,    
	}

	try {
		const res: any = await axios.post("/auth/register",vals);
		return res?.data;
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
}